import React from "react";
import { Link } from "react-router-dom";
import { artists, explore } from "../../route-link";
import { IArtwork } from "../../types/artwork/artwork";
import ArtworkNoticeAudited from "./audited-components/ArtworkNoticeAudited/ArtworkNoticeAudited";

interface DeclineTransferArtworkNotificationProps {
  nameFrom: string;
  userId: string;
  time: Date;
  artwork: IArtwork;
}

const DeclineTransferArtworkNotification: React.FC<DeclineTransferArtworkNotificationProps> = ({
  nameFrom,
  userId,
  time,
  artwork,
}) => {
  const nameArtwork = artwork?.name;
  return (
    <div className="notification_grid">
      <p className="notification_text">
        <Link className="notification_link" to={`/${explore}/${artists}/${userId}`}>
          {nameFrom}
        </Link>{" "}
        declined request to transfer artwork "{nameArtwork}"
      </p>
      <ArtworkNoticeAudited artwork={artwork} time={time} />
    </div>
  );
};

export default DeclineTransferArtworkNotification;
